import _ from "lodash";
import React, { PureComponent } from "react";

import classes from "./SubjectBenchmarks.scss";

import LockOverlay from "UIComponents/LockOverlay";
import BenchmarkView from "UIComponents/BenchmarkView";
import I18nHOC from "UIComponents/I18nHOC";
import { getElementValue } from "modules/ElementValueUtils";
import { getLabelWithArchivedText } from "Utils";
import { Button } from "@toddle-edu/ds-web";

const getElementValueMemoize = _.memoize(getElementValue, params =>
  JSON.stringify(params)
);
class SubjectBenchmarks extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      props: {
        lockedField,
        isArchived = false,
        subject,
        isEmpty,
        getEmptyComponent,
        onAddClicked,
        hasData,
        value,
        nodes,
        pypType,
        rootNodes,
        t,
        readOnly,
        testId,
      },
    } = this;
    const elementValue = getElementValueMemoize({
      valueKeys: value,
      fieldUID: "benchmarks",
      benchmarkSet: { nodes, rootNodes },
    });

    return (
      <div className={classes.mainContainer}>
        <div className={classes.headerContainer}>
          <div className={"text-label-2"}>
            {getLabelWithArchivedText({
              t,
              label: subject.label,
              isArchived: isArchived,
            })}
          </div>
          {!isEmpty && (
            <Button
              onClick={() => onAddClicked(subject)}
              variant={"outlined-subtle"}
              disabled={lockedField}
              testId={`${testId}-${subject.label}-edit`}
            >
              {t("common:edit")}
            </Button>
          )}
        </div>

        <div className={classes.mainContentContainer}>
          {!isEmpty ? (
            <div className={classes.innerContainer}>
              <BenchmarkView
                value={elementValue}
                startDepth={pypType == "benchmarks" ? 1 : 2}
                mode={"view"}
              ></BenchmarkView>
            </div>
          ) : (
            getEmptyComponent({ subject, hasData })
          )}
          {lockedField && (
            <LockOverlay userInfo={_.get(lockedField, "userInfo", {})} />
          )}
        </div>
      </div>
    );
  }
}

export default I18nHOC({ resource: "common" })(SubjectBenchmarks);
